import React, { useEffect } from 'react';
import { AmbHeader } from './components/layout/AmbHeader';
import { AmbFooter } from './components/layout/AmbFooter';
import Landing from './pages/Landing';
import { initAnalytics } from './lib/analytics';

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);

  return (
    <div className="app-wrapper">
      <AmbHeader />
      <Landing />
      <AmbFooter />
    </div>
  );
}

export default App;
